import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/custom-normalize.css';
import './styles/custom-reset.css';
import './styles/minireset.css';
import './styles/ns-select.css';
import './styles/remove.css';
import './styles/safe-area.css';
import './styles/ellipsis.css';
import App from './components/app/App.js';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
